import React, { useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { memberMobx } from '@mobxStore'
import { useHistoryListen, useHistoryNew } from '@utils'
import { Icon } from '@cps'
import MktController from '@ctrls/mktController'
import { each } from '@dt/fe-utils/dist/lodash'

const CouponBar: React.FC = () => {
  const history = useHistoryNew()
  const { unacquiredCoupons, getUnacquiredCoupons, couponListForUse } = memberMobx
  const [unacquiredCnt, setUnacquiredCnt] = useState<number>(0)
  const [couponCnt] = useState<number>(couponListForUse.length)

  const handleGo = () => {
    history.push('/iCoupon')
  }

  const handleGoGet = () => {
    MktController.checkLogin(history).then(() => {
      history.push('/iCoupon/coupon/get')
    })
  }

  useEffect(() => {
    if (unacquiredCoupons.length > 0) {
      const couponIds: any[] = []
      const couponArr: any[] = []
      let couponCnt: number = 0
      each(unacquiredCoupons, (item: any) => {
        each(item.coupons, (cItem: any) => {
          if (!couponIds.includes(cItem.couponId)) {
            couponIds.push(cItem.couponId)
          }
          for (let i = 0; i < cItem.couponCnt; i++) {
            couponArr.push({
              couponId: cItem.couponId
            })
          }
          couponCnt += cItem.couponCnt
        })
      })
      setUnacquiredCnt(couponCnt)
    } else {
      setUnacquiredCnt(0)
    }
  }, [unacquiredCoupons])

  useEffect(() => {
    if (!memberMobx.isUnacquiredInit && memberMobx.token) {
      getUnacquiredCoupons()
    }
  }, [])

  useHistoryListen((pathname: string) => {
    if (pathname === '/menu') {
      if (!memberMobx.isUnacquiredInit && memberMobx.token) {
        getUnacquiredCoupons()
      }
    }
  })

  if (!memberMobx.isLogin || (!couponCnt && !unacquiredCoupons.length)) return null

  return (
    <div className='waterfall-bt-wrap'>
      <div className='waterfall-coupon-bar-element waterfall-bt-btn' data-cypid='click-coupon-bar' onClick={unacquiredCnt ? handleGoGet : handleGo}>
        <div className='bt-icon'>
          <Icon name='quan' />
        </div>
        {
          unacquiredCnt ? (
            <div className='name'>{i18n.t('menu.hasCouponsGet', { count: unacquiredCnt })}</div>
          ) : (
            <div className='name'>{i18n.t('menu.hasCoupons', { count: couponCnt })}</div>
          )
        }
      </div>
    </div>
  )
}

export default observer(CouponBar)
